import { render, staticRenderFns } from "./CardPemeriksaanFisikDewasa.vue?vue&type=template&id=21cd31bb&scoped=true&"
import script from "./CardPemeriksaanFisikDewasa.vue?vue&type=script&lang=ts&"
export * from "./CardPemeriksaanFisikDewasa.vue?vue&type=script&lang=ts&"
import style0 from "./CardPemeriksaanFisikDewasa.vue?vue&type=style&index=0&id=21cd31bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21cd31bb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VCol,VDivider,VRadio,VRadioGroup,VRow,VTextField})
